import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { clssInfo, RegisterGradeIIndQuarter, getIIndQuarter, GetGradeIINdQuarter, updateGrade, DestroyGrade, GetMatter, GetMatterDetails } from '../../Api'

import {
    Container,
    ContainerDivs,
    List,
    ListChecked,
    Emp,
    Span,
    Conceito,
    Btt01,
    Btt02,
    Grade,
    ContainerStudent,
    EditContainer,
    ErrorMessage,
    DataSelected,
    Select,
    LegendBox,
    Info,
    BlurBackground,
    ModalContainer,
    AreaWrapper,
    Area,
    ContSelect
} from './style';

import LoadingSpinner from '../../components/Loading'

import { SlActionUndo } from "react-icons/sl";

// ── helpers fora do componente ──────────────────────────────────────
// Compara dois ids que podem vir como string crua, string JSON ou objeto.
const sameId = (a, b) => {
    const norm = (v) => {
        if (v == null) return ''
        if (typeof v === 'string') {
            const t = v.trim()
            if (t.startsWith('"') || t.startsWith('{') || t.startsWith('[')) {
                try { v = JSON.parse(t) } catch { return t }
            } else {
                return t
            }
        }
        if (Array.isArray(v)) v = v[0]
        if (v && typeof v === 'object') return String(v._id ?? v.id ?? '')
        return String(v ?? '')
    }
    const na = norm(a), nb = norm(b)
    return !!na && na === nb
}

const safeParse = (raw) => {
    try { return raw ? JSON.parse(raw) : null } catch { return raw }
}

const IndexAttendance = () => {

    const navigate = useNavigate()

    // ── status do diário (aberto/fechado para este professor) ────────
    const [open, setopen] = useState('aberto')

    // ── contexto ─────────────────────────────────────────────────────
    const [Namematter, setNameMatter] = useState('')
    const [year, setYear] = useState('')
    const [bimonthly, setBimonthly] = useState('')
    //const [totalGrade, setTotalGrade] = useState('')
    //const [averageGrade, setAverageGrade] = useState('')
    const [id_matter, setMatter] = useState('')
    const [id_class, setId_class] = useState('')
    const [id_iiNdQuarter, setId_iiNdQuarter] = useState('')
    const [id_teacher, setId_teacher] = useState('')

    // ── listas ───────────────────────────────────────────────────────
    const [stdt, setStdt] = useState([])          // alunos sem conceito (a lançar)
    const [checked, setChecked] = useState([])     // conceitos já lançados

    // ── papéis de professor ──────────────────────────────────────────
    const [RegentTeacher, setclassRegentTeacher] = useState(null)
    const [RegentTeacher02, setclassRegentTeacher02] = useState(null)
    const [physicalEducation, setphysicalEducationTeacher] = useState(null)

    // ── edição inline ────────────────────────────────────────────────
    const [namestudent, setNamestudent] = useState(null)
    const [update_id_grade, setUpdateIdGrade] = useState(null)
    const [update_studentGrade, setUpdateStudentGrade] = useState('')
    const [savingEdit, setSavingEdit] = useState(false)

    // ── UI ───────────────────────────────────────────────────────────
    const [loading, setLoading] = useState(true)   // começa carregando
    const [loadError, setLoadError] = useState('') // erro de carregamento (com retry)
    const [errorMessage, setErrorMessage] = useState('')
    const [warning, setWarning] = useState('')      // aviso não-bloqueante (substitui alert)
    const [finalizing, setFinalizing] = useState(false)

    const [confirmModal, setConfirmModal] = useState(false)
    const [selectedGrade, setSelectedGrade] = useState(null)
    const [deleting, setDeleting] = useState(false)

    const [matter, setMttr] = useState([])
    const [selectedMatter, setSelectedMatter] = useState('')
    const [definingMatter, setDefiningMatter] = useState(false)

    const [showMatterUpdated, setShowMatterUpdated] = useState(false)

    const [assessmentRegime, setAssessmentRegime] = useState('')

    // controla cancelamento em desmontagem / reexecução
    const mountedRef = useRef(true)
    // chave para forçar recarregar os dados (substitui window.location.reload)
    const [reloadKey, setReloadKey] = useState(0)

    // ── monta listas a partir de grades + turma (lógica única / DRY) ──
    const buildLists = useCallback((resGrade, resClass) => {
        const realized = (resGrade?.data?.data || [])
        const realizedIds = realized.map(r => r?.id_student?._id).filter(Boolean)

        const turma = (resClass?.data?.data || []).find(Boolean)
        const allStudents = turma?.id_student || []

        const pending = allStudents
            .filter(s => s && !realizedIds.includes(s._id))
            .map(s => ({ ...s, concept: '' }))

        return { pending, realized }
    }, [])

    // ── CARGA PRINCIPAL ──────────────────────────────────────────────
    useEffect(() => {
        mountedRef.current = true
        let cancelled = false

        const safeSet = (fn) => { if (!cancelled && mountedRef.current) fn() }

            ; (async () => {
                safeSet(() => { setLoading(true); setLoadError('') })

                // tudo que vem do storage é lido uma vez
                const idSchoolRaw = sessionStorage.getItem('id-school')
                const idSchool = safeParse(idSchoolRaw)
                const teacherRaw = localStorage.getItem('Id_employee')
                const teacherId = safeParse(teacherRaw)
                const currentYear = sessionStorage.getItem('yearGrade')
                const id_bimonthly = sessionStorage.getItem('id-II')
                const nameMatter = sessionStorage.getItem('nameMatter')
                const id_mttr = sessionStorage.getItem('Selectmatter')
                const classId = sessionStorage.getItem('class-info')

                const regent = safeParse(sessionStorage.getItem('classRegentTeacher'))
                const regent02 = safeParse(sessionStorage.getItem('classRegentTeacher02'))
                const physical = safeParse(sessionStorage.getItem('physicalEducationTeacher'))

                // estados de contexto (não dependem das chamadas de rede)
                safeSet(() => {
                    setAssessmentRegime(sessionStorage.getItem('assessmentRegime') || '')
                    setclassRegentTeacher(regent)
                    setclassRegentTeacher02(regent02)
                    setphysicalEducationTeacher(physical)
                    setMatter(id_mttr || '')
                    setYear(currentYear || '')
                    setId_iiNdQuarter(id_bimonthly || '')
                    setNameMatter(nameMatter || '')
                    setId_class(classId || '')
                    setId_teacher(teacherId)
                })

                // validação mínima antes de chamar a API
                if (!currentYear || !id_bimonthly || !id_mttr || !classId) {
                    safeSet(() => {
                        setLoadError('Não foi possível carregar os dados da turma. Volte e selecione a disciplina novamente.')
                        setLoading(false)
                    })
                    return
                }

                try {
                    // dispara TODAS as chamadas em paralelo (mais rápido)
                    const [resQuarter, resClass, resGrade, resMatter] = await Promise.all([
                        getIIndQuarter(currentYear, idSchool),
                        clssInfo(classId),
                        GetGradeIINdQuarter(currentYear, id_mttr, id_bimonthly, classId),
                        GetMatter(idSchool)
                    ])

                    if (cancelled || !mountedRef.current) return

                    // status do diário (aberto/fechado) conforme tipo de professor
                    const turma = (resClass?.data?.data || []).find(Boolean)
                    if (turma?.dailyStatus?.['2º BIMESTRE']) {
                        const st = turma.dailyStatus['2º BIMESTRE']
                        const isPhysical = sameId(teacherId, physical)
                        safeSet(() => setopen(isPhysical ? st.physicalEducationTeacher : st.regentTeacher))
                    }

                    // dados do quarter (bimonthly/total/average) — concatenados como antes
                    const quarterRows = resQuarter?.data?.data || []
                    safeSet(() => {
                        setBimonthly(quarterRows.map(r => r.bimonthly).join(' '))
                        //setTotalGrade(quarterRows.map(r => r.totalGrade).join(' '))
                        //setAverageGrade(quarterRows.map(r => r.averageGrade).join(' '))
                    })

                    // listas de alunos (a lançar) e conceitos lançados
                    const { pending, realized } = buildLists(resGrade, resClass)
                    safeSet(() => {
                        setStdt(pending)
                        setChecked(realized)
                    })

                    // disciplinas para o seletor "trocar disciplina"
                    const allMatters = resMatter?.data?.data || []
                    const isPhysical = sameId(teacherId, physical)
                    const filterMatter = allMatters.filter(m =>
                        isPhysical ? m.name === 'EDUCAÇÃO FÍSICA' : m.name !== 'EDUCAÇÃO FÍSICA'
                    )
                    safeSet(() => setMttr(filterMatter))

                    safeSet(() => { setLoading(false); setLoadError('') })
                } catch (err) {
                    console.error('Erro ao carregar a página de grade:', err)
                    safeSet(() => {
                        setLoadError('Erro ao carregar os dados. Verifique sua conexão e tente novamente.')
                        setLoading(false)
                    })
                }
            })()

        return () => { cancelled = true; mountedRef.current = false }
        // só recarrega quando explicitamente pedido (reloadKey)
    }, [reloadKey, buildLists])

    // aviso "disciplina alterada" (vindo do fluxo antigo de troca)
    useEffect(() => {
        const changed = sessionStorage.getItem('matterChanged')
        if (changed === 'true') {
            setShowMatterUpdated(true)
            sessionStorage.removeItem('matterChanged')
            const t = setTimeout(() => setShowMatterUpdated(false), 6000)
            return () => clearTimeout(t)
        }
    }, [])

    // limpa o aviso não-bloqueante depois de alguns segundos
    useEffect(() => {
        if (!warning) return
        const t = setTimeout(() => setWarning(''), 6000)
        return () => clearTimeout(t)
    }, [warning])

    // recarrega listas em memória (sem reload de página)
    const refreshGradesAndStudents = useCallback(async () => {
        try {
            const [resGrade, resClass] = await Promise.all([
                GetGradeIINdQuarter(year, id_matter, id_iiNdQuarter, id_class),
                clssInfo(id_class)
            ])
            if (!mountedRef.current) return
            const { pending, realized } = buildLists(resGrade, resClass)
            setStdt(pending)
            setChecked(realized)
            setErrorMessage('')
        } catch (err) {
            console.error(err)
            if (mountedRef.current) setErrorMessage('Erro ao atualizar as listas.')
        }
    }, [year, id_matter, id_iiNdQuarter, id_class, buildLists])

    // atualiza conceito local de um aluno (não envia)
    const handleConceptChange = (studentId, value) => {
        setStdt(prev => prev.map(s => s._id === studentId ? { ...s, concept: value } : s))
        setErrorMessage('')
    }

    // resolve teacher01/teacher02 conforme o papel (mesma regra de antes)
    const resolveTeachers = () => {
        let teacher01 = id_teacher
        let teacher02 = null
        if (sameId(RegentTeacher, id_teacher)) {
            teacher02 = RegentTeacher02
        } else if (sameId(RegentTeacher02, id_teacher)) {
            teacher02 = RegentTeacher02
            teacher01 = RegentTeacher
        } else if (sameId(physicalEducation, id_teacher)) {
            teacher02 = null
        }
        return { teacher01, teacher02 }
    }

    // ── envia todos os conceitos preenchidos de uma vez ──────────────
    const handleFinalize = async () => {
        if (finalizing) return

        const toSend = stdt.filter(s => s.concept && s.concept.trim() !== '')

        if (toSend.length === 0) {
            setErrorMessage('Preencha ao menos um conceito antes de finalizar.')
            return
        }

        const semConceito = stdt.length - toSend.length
        if (semConceito > 0) {
            const msgSemConceito = `Atenção: ${semConceito} aluno(s) sem conceito definido não serão enviados.`
            setWarning(msgSemConceito)
            // alert do navegador para garantir visibilidade mesmo com a página rolada
            alert(msgSemConceito)
        }

        setFinalizing(true)
        setErrorMessage('')

        try {
            const { teacher01, teacher02 } = resolveTeachers()

            const promises = toSend.map(s =>
                RegisterGradeIIndQuarter(
                    year,
                    bimonthly,
                    s.concept,
                    id_iiNdQuarter,
                    s._id,
                    teacher01,
                    teacher02,
                    id_matter,
                    id_class
                )
            )

            await Promise.all(promises)
            await refreshGradesAndStudents()
        } catch (err) {
            console.error(err)
            if (mountedRef.current) setErrorMessage('Erro ao enviar conceitos. Tente novamente.')
        } finally {
            if (mountedRef.current) setFinalizing(false)
        }
    }

    // ── edição ───────────────────────────────────────────────────────
    const startEditing = (grade) => {
        setUpdateStudentGrade(grade.studentGrade ?? '')
        setUpdateIdGrade(grade._id)
        setNamestudent(grade)
        setErrorMessage('')
    }

    const cancelEditing = () => {
        if (savingEdit) return
        setUpdateIdGrade(null)
        setNamestudent(null)
        setUpdateStudentGrade('')
    }

    const saveEdit = async () => {
        if (savingEdit) return
        if (!update_studentGrade) {
            setErrorMessage('Selecione um conceito ou marque "Não adicionar".')
            return
        }
        setSavingEdit(true)
        setErrorMessage('')
        try {
            await updateGrade(update_id_grade, update_studentGrade)
            if (!mountedRef.current) return
            // atualiza em memória: tira da edição e recarrega listas
            setUpdateIdGrade(null)
            setNamestudent(null)
            setUpdateStudentGrade('')
            await refreshGradesAndStudents()
        } catch (err) {
            console.error(err)
            if (mountedRef.current) setErrorMessage('Erro ao salvar a alteração. Tente novamente.')
        } finally {
            if (mountedRef.current) setSavingEdit(false)
        }
    }

    const Return = () => navigate(-1)

    // ── exclusão ─────────────────────────────────────────────────────
    const handleDeleteClick = (grade) => {
        setSelectedGrade(grade)
        setConfirmModal(true)
    }

    const handleConfirm = async () => {
        if (!selectedGrade || deleting) return
        setDeleting(true)
        try {
            await DestroyGrade(selectedGrade._id)
            if (!mountedRef.current) return
            setConfirmModal(false)
            setSelectedGrade(null)
            await refreshGradesAndStudents()
        } catch (err) {
            console.error(err)
            if (mountedRef.current) setErrorMessage('Erro ao deletar o conceito. Tente novamente.')
        } finally {
            if (mountedRef.current) setDeleting(false)
        }
    }

    const handleCancel = () => {
        if (deleting) return
        setConfirmModal(false)
        setSelectedGrade(null)
    }

    // ── trocar disciplina (sem reload) ───────────────────────────────
    const handleDefineMatter = async () => {
        if (definingMatter) return
        if (!selectedMatter) {
            setWarning('Selecione uma matéria.')
            return
        }
        setDefiningMatter(true)
        setErrorMessage('')
        try {
            const Matter = await GetMatterDetails(selectedMatter)
            const nameMatter = Matter?.data?.name || ''

            sessionStorage.setItem('Selectmatter', selectedMatter)
            sessionStorage.setItem('nameMatter', nameMatter)

            if (!mountedRef.current) return
            // atualiza contexto e recarrega os dados da nova disciplina
            setMatter(selectedMatter)
            setNameMatter(nameMatter)
            setSelectedMatter('')
            setShowMatterUpdated(true)
            setTimeout(() => mountedRef.current && setShowMatterUpdated(false), 6000)
            setReloadKey(k => k + 1) // dispara a carga novamente
        } catch (err) {
            console.error(err)
            if (mountedRef.current) setErrorMessage('Erro ao trocar a disciplina. Tente novamente.')
        } finally {
            if (mountedRef.current) setDefiningMatter(false)
        }
    }

    // ── RENDER ───────────────────────────────────────────────────────
    if (loading) {
        return (
            <Container>
                <LoadingSpinner />
            </Container>
        )
    }

    // erro de carregamento com opção de tentar de novo (não trava a tela)
    if (loadError) {
        return (
            <Container>
                <ContainerDivs>
                    <DataSelected>
                        <SlActionUndo fontSize={'30px'} onClick={Return} />
                    </DataSelected>
                    <ErrorMessage>{loadError}</ErrorMessage>
                    <Btt02 onClick={() => setReloadKey(k => k + 1)}>Tentar novamente</Btt02>
                </ContainerDivs>
            </Container>
        )
    }

    return (
        <Container>
            <ContainerDivs>
                {assessmentRegime === 'BIMESTRAL' && <h2>Grade Bimestral</h2>}
                {assessmentRegime === 'TRIMESTRAL' && <h2>Grade Trimestral</h2>}

                {open === 'aberto' ? (
                    <>
                        <AreaWrapper>
                            <Area>
                                <h3>Selecionar Outra Disciplina</h3>
                                <Select
                                    id="id-matter"
                                    value={selectedMatter}
                                    onChange={(e) => setSelectedMatter(e.target.value)}
                                >
                                    <option value="">Selecione a disciplina</option>
                                    {matter.map(res => (
                                        <option key={res._id} value={res._id}>
                                            {res.name}
                                        </option>
                                    ))}
                                </Select>
                                <Btt02 onClick={handleDefineMatter} disabled={definingMatter}>
                                    {definingMatter ? 'Definindo...' : 'Definir'}
                                </Btt02>
                            </Area>
                        </AreaWrapper>

                        <ContainerStudent>
                            <DataSelected>
                                <SlActionUndo fontSize={'30px'} onClick={Return} />
                                <Info>
                                    {assessmentRegime === 'BIMESTRAL' && <p>2º Bimestre</p>}
                                    {assessmentRegime === 'TRIMESTRAL' && <p>2º Trimestre</p>}
                                    <p>Disciplina: {Namematter}</p>
                                </Info>
                                <LegendBox>
                                    <h3>Legenda</h3>
                                    <p><strong style={{ color: '#1d7f14' }}>A</strong> - Alcançou com êxito as capacidades básicas</p>
                                    <p><strong style={{ color: 'blue' }}>B</strong> - Alcançou satisfatoriamente as capacidades básicas</p>
                                    <p><strong style={{ color: 'orange' }}>C</strong> - Alcançou parcialmente as capacidades básicas</p>
                                    <p><strong style={{ color: 'red' }}>D</strong> - Não alcançou as capacidades básicas</p>
                                </LegendBox>
                            </DataSelected>

                            {/* aviso não-bloqueante (substitui o alert) */}
                            {warning && <ErrorMessage>{warning}</ErrorMessage>}
                            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

                            {!update_id_grade && (
                                <>
                                    <List>
                                        {stdt.length === 0 ? (
                                            <p>Todos os alunos já possuem conceito lançado nesta disciplina.</p>
                                        ) : (
                                            [...stdt]
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map(stdtItem => (
                                                    <React.Fragment key={stdtItem._id}>
                                                        <Emp>
                                                            <Span>{stdtItem.name}</Span>
                                                            <Grade>
                                                                <ContSelect>
                                                                    <p>Conceito:</p>
                                                                    <Select
                                                                        value={stdtItem.concept}
                                                                        onChange={(e) => handleConceptChange(stdtItem._id, e.target.value)}
                                                                        disabled={stdtItem.concept === '-'}
                                                                    >
                                                                        <option value="">Selecione</option>
                                                                        <option value="A">A</option>
                                                                        <option value="B">B</option>
                                                                        <option value="C">C</option>
                                                                        <option value="D">D</option>
                                                                    </Select>
                                                                </ContSelect>
                                                                <label style={{ marginTop: '6px', display: 'flex', alignItems: 'center' }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={stdtItem.concept === '-'}
                                                                        onChange={(e) =>
                                                                            handleConceptChange(stdtItem._id, e.target.checked ? '-' : '')
                                                                        }
                                                                    />
                                                                    <span style={{ marginLeft: '6px' }}>
                                                                        Não adicionar para este aluno
                                                                    </span>
                                                                </label>
                                                            </Grade>
                                                        </Emp>
                                                    </React.Fragment>
                                                ))
                                        )}

                                        {stdt.length > 0 && (
                                            <Btt01 onClick={handleFinalize} disabled={finalizing}>
                                                {finalizing ? 'Enviando...' : 'Finalizar'}
                                            </Btt01>
                                        )}
                                    </List>

                                    {checked.length > 0 && (
                                        <ListChecked>
                                            {[...checked]
                                                .sort((a, b) => a.id_student.name.localeCompare(b.id_student.name))
                                                .map(item => (
                                                    <Emp key={item._id}>
                                                        <Span>{item.id_student.name}</Span>
                                                        <Grade>
                                                            <p>Conceito: </p>
                                                            <Conceito grade={item.studentGrade}>{item.studentGrade}</Conceito>
                                                        </Grade>
                                                        <Btt02 onClick={() => startEditing(item)}>Editar</Btt02>
                                                        <Btt02 onClick={() => handleDeleteClick(item)}>Deletar</Btt02>
                                                    </Emp>
                                                ))}

                                            {confirmModal && (
                                                <BlurBackground>
                                                    <ModalContainer>
                                                        <h3>
                                                            Tem certeza que deseja deletar o conceito de{' '}
                                                            <strong>{selectedGrade?.id_student?.name}</strong>?
                                                        </h3>
                                                        <div>
                                                            <button
                                                                style={{ backgroundColor: 'red', color: 'white' }}
                                                                onClick={handleConfirm}
                                                                disabled={deleting}
                                                            >
                                                                {deleting ? 'Deletando...' : 'Sim'}
                                                            </button>
                                                            <button onClick={handleCancel} disabled={deleting}>Não</button>
                                                        </div>
                                                    </ModalContainer>
                                                </BlurBackground>
                                            )}
                                        </ListChecked>
                                    )}
                                </>
                            )}

                            {update_id_grade && namestudent && (
                                <EditContainer>
                                    <h3>Editando Nota</h3>
                                    <Emp>
                                        <Span>{namestudent?.id_student?.name}</Span>
                                        <Grade>
                                            <p>Conceito: </p>
                                            <Select
                                                value={update_studentGrade}
                                                onChange={(e) => setUpdateStudentGrade(e.target.value)}
                                                disabled={update_studentGrade === '-'}
                                            >
                                                <option value="">Selecione</option>
                                                <option value="A">A</option>
                                                <option value="B">B</option>
                                                <option value="C">C</option>
                                                <option value="D">D</option>
                                            </Select>
                                            <label style={{ marginTop: '6px', display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={update_studentGrade === '-'}
                                                    onChange={(e) => setUpdateStudentGrade(e.target.checked ? '-' : '')}
                                                />
                                                <span style={{ marginLeft: '6px' }}>
                                                    Não adicionar para este aluno
                                                </span>
                                            </label>
                                        </Grade>
                                    </Emp>
                                    <Btt02 onClick={saveEdit} disabled={savingEdit}>
                                        {savingEdit ? 'Salvando...' : 'Salvar'}
                                    </Btt02>
                                    <Btt02 onClick={cancelEditing} disabled={savingEdit}>Cancelar</Btt02>
                                </EditContainer>
                            )}
                        </ContainerStudent>
                    </>
                ) : (
                    <p>período fechado, para editar contate o Diretor ou Supervisor.</p>
                )}

                {showMatterUpdated && (
                    <div style={{
                        position: 'fixed',
                        top: '120px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: '#4caf50',
                        color: '#fff',
                        padding: '12px 20px',
                        borderRadius: '8px',
                        zIndex: 9999,
                        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                        fontWeight: 'bold'
                    }}>
                        A disciplina foi alterada com sucesso.
                    </div>
                )}
            </ContainerDivs>
        </Container>
    )
}

export default IndexAttendance
